import React from 'react';
import { PricingVariant } from '@wix/ambassador-pricing-plans-v3-plan/types';
import { TPA_EXPERIMENTS } from '@wix/pricing-plans-common/experiments';
import { VIEWER_HOOKS } from '@wix/pricing-plans-common/hooks';
import { useStyles } from '@wix/tpa-settings/react';
import { useExperiments, useTranslation } from '@wix/yoshi-flow-editor';
import { NO_BREAK_SPACE } from '../../../../../constants';
import { useStylesParams } from '../../../../../hooks';
import { getVariantPeriodLabel } from '../../../../../utils/plan';
import { st, classes } from './Recurrence.st.css';

export interface RecurrenceProps {
  variant: PricingVariant | undefined;
  recurringPlansExist: boolean;
  highlighted: boolean;
}

export const Recurrence: React.FC<RecurrenceProps> = ({ variant, recurringPlansExist, highlighted }) => {
  const { t } = useTranslation();
  const { experiments } = useExperiments();
  const styles = useStyles();
  const stylesParams = useStylesParams();
  const fontSize = stylesParams.planRecurringOptionsFontSize
    ? styles.get(stylesParams.planRecurringOptionsFontSize)
    : undefined;
  const isFontSizeEnabled = experiments.enabled(TPA_EXPERIMENTS.FONT_SIZE_FOR_TPA_ELEMENTS);

  if (!recurringPlansExist) {
    return null;
  }

  return (
    <span
      data-hook={VIEWER_HOOKS.PLAN_RECURRENCE}
      className={st(classes.frequency, { highlighted })}
      style={isFontSizeEnabled ? { fontSize: `${fontSize}px` } : undefined}
    >
      {getVariantPeriodLabel(variant!, t) ?? NO_BREAK_SPACE}
    </span>
  );
};
